export default "__VITE_ASSET__DWhf0jvr__"